import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap'; 

const IconBox = ({ Icon, text }) => {
  return (
    <Col xs={4} md={2} className="tech-icons">
      <Icon />
      <p style={{ color: 'white', fontSize: '18px' }}>{text}</p>
    </Col>
  );
};

IconBox.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  text: PropTypes.string.isRequired,
};

export default IconBox;
